var root = globalThis;
if (root.__PlasmicTokenRegistry == null) {
    root.__PlasmicTokenRegistry = [];
}
function registerToken(token) {
    root.__PlasmicTokenRegistry.push(token);
}

export { registerToken as default };
